const LoadingPage = () => {
  return (
    <div />
  );
}

export default LoadingPage;